import { useParams } from 'react-router-dom';
import { Form, FormProps } from 'components';
import { useCallback, useEffect } from 'react';
import { getUpdatedPayload } from 'utils/helpers';
import { useSupplierLegalUpdateMutation } from 'api';
import { PaymentGeneralFieldType } from 'typings/form/client/payment';
import { useNotificationMessages } from 'hooks/useNotificationMessages';
import { ILegalEditeModal } from './index';

export const useLegalEditModal = (props: ILegalEditeModal) => {
  const { onModalStateChange, modalState, dataToEdit } = props;
  const [form] = Form.useForm();
  const { id } = useParams() as { id: string };
  const { handleError, handleSuccess } = useNotificationMessages();

  const [updateLegal, { isLoading }] = useSupplierLegalUpdateMutation();

  const onCancel = useCallback(() => {
    form.resetFields();
    onModalStateChange();
  }, [form, onModalStateChange]);

  const onFinish: FormProps<PaymentGeneralFieldType>['onFinish'] = useCallback(
    async (values: PaymentGeneralFieldType) => {
      const payload = getUpdatedPayload(values, dataToEdit);
      payload.id = id;
      try {
        const { data, error }: Record<string, any> = await updateLegal(payload);
        if (data?.success) {
          handleSuccess('Legal Information was successfully updated.');
          onCancel();
        } else {
          handleError(error);
        }
      } catch (err) {
        handleError(err);
      }
    },
    [updateLegal, id, onCancel, dataToEdit, handleError, handleSuccess]
  );

  useEffect(() => {
    if (modalState && dataToEdit) {
      form.setFieldsValue(dataToEdit);
    }
  }, [modalState, dataToEdit, form]);

  return {
    onFinish,
    onCancel,
    form,
    isLoading,
  };
};
